import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useBeforeunload } from "react-beforeunload";
import * as authService from "./../services/auth";

import useAuthStore from "./../states/zustand/authStore";

type Props = { roles: string[] };

const PrivateRoutes: FC<Props> = ({ roles }) => {
  const location = useLocation();

  const { setProfileDataEmpty, profileData } = useAuthStore((state) => state);

  const logoutHandler = () => {
    setProfileDataEmpty();
    authService.logout();
  };

  useBeforeunload((event) => {
    // if (condition) {
    //   event.preventDefault();
    //   return "You will be logged out, are you sure?";
    // }
    // logoutHandler()
  });

  return profileData.isAuth && roles.includes(profileData.role) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoutes;
